import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useLoaderData } from 'react-router-dom';
import PDFdownload from '../PDFdownload/PDFdownload';



const CourseDetails = () => {
    const course = useLoaderData();
    const { title, price, description, category, image } = course;

    return (
        <div>
            <div className='text-center mt-5'><h4>Download the course Details</h4>
                <PDFdownload
                    price={price}
                    title= {title}
                    description = {description}
                    category = {category}
                    image= {image}>
                </PDFdownload>
                <Button variant="outline-dark"><Link to={'/checkout'}>Get Premium Access</Link></Button>
            </div>
        </div>
    );
};

export default CourseDetails;